import { UI_THEMES } from "ui/model"
import { IUserInfo } from "user/model"
import { setTheme } from "./theme"

export function applyUiFeaturePreferences(userInfo: IUserInfo): void {
  setTheme(userInfo.user.ui_settings.theme === UI_THEMES.DARK)
}
